import React from 'react';
import './HowItWorks.css';

const clientSteps = [
  { step: '01', icon: '📲', title: 'Download & Register', desc: 'Get the AfreXpert app on App Store or Google Play and create your free account in minutes.' },
  { step: '02', icon: '🔍', title: 'Search for a Service', desc: 'Browse categories or search for the exact service you need — plumber, tutor, cleaner, and more.' },
  { step: '03', icon: '📅', title: 'Book an Appointment', desc: 'Select a professional, choose a time that works, and confirm your booking instantly.' },
  { step: '04', icon: '💬', title: 'Chat & Confirm', desc: 'Message your professional directly through the app to clarify details and confirm the visit.' },
  { step: '05', icon: '⭐', title: 'Rate & Review', desc: 'After the job is done, rate your experience and help others find great professionals.' },
];

const proSteps = [
  { step: '01', icon: '📝', title: 'Create a Profile', desc: 'Sign up as a professional and build your profile showcasing your skills and experience.' },
  { step: '02', icon: '✅', title: 'Get Verified', desc: 'Pass our quick verification process to build client trust and credibility.' },
  { step: '03', icon: '📢', title: 'Post Your Services', desc: 'List your services with pricing, availability, and photos of your work.' },
  { step: '04', icon: '📩', title: 'Receive Bookings', desc: 'Get notified when clients book you. Accept, manage, and track all appointments from the app.' },
  { step: '05', icon: '💰', title: 'Get Paid Securely', desc: 'Receive payments directly and build your reputation through verified reviews.' },
];

export default function HowItWorks() {
  return (
    <div className="page hiw-page">
      <section className="hiw-hero">
        <div className="container">
          <span className="section-label">Simple Process</span>
          <h1 className="section-title">How AfreXpert Works</h1>
          <p className="section-desc">Whether you're looking for help or offering your expertise, AfreXpert makes it simple and seamless.</p>
        </div>
      </section>

      <section className="hiw-section">
        <div className="container">
          <div className="hiw-tabs-wrapper">
            <div className="hiw-panel">
              <div className="panel-header client">
                <span className="panel-icon">👤</span>
                <div>
                  <h2>For Clients</h2>
                  <p>Find and hire trusted professionals effortlessly</p>
                </div>
              </div>
              <div className="steps-list">
                {clientSteps.map((s, i) => (
                  <div key={i} className="step-item">
                    <div className="step-number">{s.step}</div>
                    <div className="step-icon">{s.icon}</div>
                    <div className="step-content">
                      <h3>{s.title}</h3>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="hiw-divider">
              <div className="divider-icon">⇄</div>
            </div>

            <div className="hiw-panel">
              <div className="panel-header pro">
                <span className="panel-icon">🔨</span>
                <div>
                  <h2>For Professionals</h2>
                  <p>Grow your business and reach more clients</p>
                </div>
              </div>
              <div className="steps-list">
                {proSteps.map((s, i) => (
                  <div key={i} className="step-item">
                    <div className="step-number">{s.step}</div>
                    <div className="step-icon">{s.icon}</div>
                    <div className="step-content">
                      <h3>{s.title}</h3>
                      <p>{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hiw-cta">
        <div className="container hiw-cta-inner">
          <h2>Ready to get started?</h2>
          <p>Download AfreXpert today — it's free for everyone.</p>
          <div className="hiw-store-btns">
            <a href="https://apps.apple.com" className="btn-primary" target="_blank" rel="noopener noreferrer">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" /></svg>
              App Store</a>
            <a href="https://play.google.com" className="btn-outline" target="_blank" rel="noopener noreferrer">▶ Google Play</a>
          </div>
        </div>
      </section>
    </div>
  );
}
